import React, { useEffect, useState } from 'react';
import { fetchSalesPersonData, transformProposalData } from '../hooks/proposalFunctions';
import API_BASE_URL from '../../../../../Constants';
import WorkPhaseModal from '../../WorkPhase/WorkPhaseModal';
import { useNavigate } from 'react-router-dom';




const ProposalLog = ({ formData, handleChange, setFormData, handleSalesPersonChange }) => {
    const [salesPersonData, setSalesPersonData] = useState([]);
    const [isPhaseModalOpen, setIsPhaseModalOpen] = useState(false);
    const navigate = useNavigate();
    const togglePhaseModal = () => {
        setIsPhaseModalOpen((prev) => !prev);
    };

    // Fetch sales person data 
    useEffect(() => {
        fetchSalesPersonData(setSalesPersonData);
    }, []);


    // Handle Save
    const handleSave = async (e) => {
        e.preventDefault();
        const transformedData = transformProposalData(formData);
        const url = `${API_BASE_URL}/api/proposals-and-jobs/proposals/${formData.proposalNumber}`;

        try {
            const response = await fetch(url, {
                method: 'PUT',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(transformedData),
            });

            if (!response.ok) throw new Error('Failed to save proposal');
            navigate("/proposals-and-jobs/proposals-and-jobs-list");

        } catch (e) {
            console.error(e);
        }
    };



    return (
        <div className="border rounded-lg shadow-lg border-black p-4 mb-4">
            <h2 className="text-2xl font-bold mb-4">Proposal Log</h2>
            <button
                className="px-6 py-2 bg-blue-600 text-white font-bold rounded-md hover:bg-blue-700 transition"
                onClick={togglePhaseModal}
                type='button'
            >
                Manage Work Phases
            </button>
            <div className="flex flex-col space-y-4 p-4 mb-4">
                <div className="flex justify-between space-x-4">
                    <>
                        <WorkPhaseModal
                            open={isPhaseModalOpen}
                            handleClose={togglePhaseModal}
                            proposalNumber={formData?.proposalNumber}
                            buildingId={formData?.buildingId}
                        />
                    </>
                </div>


                {/* Row 1: Proposal Number and Sales Person */}
                <div className="flex justify-between space-x-4">
                    <label className="block text-gray-700 text-sm font-bold w-1/2">
                        Proposal Number
                        <p className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline mt-1">{formData.proposalNumber}</p>
                    </label>
                    <label className="block text-gray-700 text-sm font-bold w-1/2">
                        Sales Person
                        <input
                            type="text"
                            name="salesPersonName"
                            value={formData.salesPersonName}
                            onChange={handleSalesPersonChange}  // Updated handler
                            list="salesPersonList"
                            readOnly={false}
                            className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline mt-1"
                        />
                        <datalist id="salesPersonList">
                            {salesPersonData.map((salesPerson) => (
                                <option key={salesPerson.id} value={salesPerson.id}>
                                    {salesPerson.firstName} {salesPerson.lastName}
                                </option>
                            ))}
                        </datalist>
                    </label>
                </div>
                {/* Row 2: Building Site and Proposal Status */}
                <div className="flex justify-between space-x-4">
                    <div className='w-1/2'>
                        <label className="block text-gray-700 text-sm font-bold mb-2">
                            Building Site:
                        </label>
                        {/* <input type="text"
                            name="buildingSite"
                            value={formData.buildingSite}
                            readOnly={false}
                            className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline mt-1"
                        /> */}
                        <p className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline mt-1">{formData.buildingSite}</p>
                    </div>
                    <div className="w-1/2">
                        <label className="block text-gray-700 text-sm font-bold w-full">
                            Proposal Status
                            <select
                                name="proposalStatus"
                                value={formData.proposalStatus}
                                onChange={handleChange}
                                className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline mt-1"
                            >
                                <option value="" disabled>Select Proposal Status</option>
                                {[
                                    'New',
                                    'New - document created',
                                    'Pending - document sent',
                                    'Accepted',
                                    'Accepted - Change Order',
                                    'Proposal Rejected',
                                    'Expired'
                                ].map((status, index) => (
                                    <option key={index} value={status}>
                                        {status}
                                    </option>
                                ))}
                            </select>
                        </label>

                        {/* Conditionally Render Fields */}
                        {['New', 'New - document created', 'Pending - document sent', 'Expired'].includes(formData.proposalStatus) && (
                            <div className="mt-2">
                                <label className="block text-gray-700 text-sm font-bold">
                                    Days Valid
                                    <input
                                        type="number"
                                        name="daysValid"
                                        value={formData.daysValid}
                                        onChange={handleChange}
                                        className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline mt-1"
                                    />
                                </label>
                            </div>
                        )}

                        {['Accepted', 'Accepted - Change Order'].includes(formData.proposalStatus) && (
                            <>
                                <div className="mt-2">
                                    <label className="block text-gray-700 text-sm font-bold">
                                        Approval Date
                                        <input
                                            type="datetime-local"
                                            name="approvalDate"
                                            value={formData.approvalDate}
                                            onChange={handleChange}
                                            className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline mt-1"
                                        />
                                    </label>
                                </div>
                                <div className="mt-2">
                                    <label className="block text-gray-700 text-sm font-bold">
                                        Approved By
                                        <input
                                            type="text"
                                            name="approvedBy"
                                            value={formData.approvedBy}
                                            onChange={handleChange}
                                            className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline mt-1"
                                        />
                                    </label>
                                </div>
                                <div className="mt-2">
                                    <label className="block text-gray-700 text-sm font-bold flex items-center">
                                        <input
                                            type="checkbox"
                                            name="isApproved"
                                            checked={formData.isApproved}
                                            onChange={(e) => setFormData((prev) => ({
                                                ...prev,
                                                isApproved: e.target.checked
                                            }))}
                                            className="mr-2"
                                        />
                                        Is Approved
                                    </label>
                                </div>
                            </>
                        )}

                        {formData.proposalStatus === 'Accepted - Change Order' && (
                            <div className="mt-2">
                                <label className="block text-gray-700 text-sm font-bold">
                                    Change Order
                                    <input
                                        type="text"
                                        name="changeOrder"
                                        value={formData.changeOrder}
                                        onChange={handleChange}
                                        className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline mt-1"
                                    />
                                </label>
                            </div>
                        )}

                        {formData.proposalStatus === 'Proposal Rejected' && (
                            <>
                                <div className="mt-2">
                                    <label className="block text-gray-700 text-sm font-bold">
                                        Cancellation Date
                                        <input
                                            type="datetime-local"
                                            name="cancellationDate"
                                            value={formData.cancellationDate}
                                            onChange={handleChange}
                                            className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline mt-1"
                                        />
                                    </label>
                                </div>
                                <div className="mt-2">
                                    <label className="block text-gray-700 text-sm font-bold">
                                        Cancelled By
                                        <input
                                            type="text"
                                            name="cancelledBy"
                                            value={formData.cancelledBy}
                                            onChange={handleChange}
                                            className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline mt-1"
                                        />
                                    </label>
                                </div>
                            </>
                        )}

                        {formData.proposalStatus === 'Expired' && (
                            <>
                                <div className="mt-2">
                                    <label className="block text-gray-700 text-sm font-bold">
                                        Expiration Date
                                        <input
                                            type="datetime-local"
                                            name="expirationDate"
                                            value={formData.expirationDate}
                                            onChange={handleChange}
                                            className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline mt-1"
                                        />
                                    </label>
                                </div>
                            </>
                        )}
                    </div>
                </div>
                {/* Row 3: Customer Number, Device ID, and Days Valid */}
                <div className="flex justify-between space-x-4">
                    {/* Left Side: Customer Number and Device ID */}
                    {/* <div className="flex flex-col w-1/2 space-y-4">
                        <label className="block text-gray-700 text-sm font-bold">
                            Customer Number
                            <input
                                type="text"
                                name="customerNumber"
                                value={formData.customerNumber}
                                readOnly={true}
                                className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline mt-1"
                            />
                        </label>
                        <label className="block text-gray-700 text-sm font-bold">
                            Device ID
                            <input
                                type="text"
                                name="deviceId"
                                value={formData.deviceId}
                                readOnly={true}
                                className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline mt-1"
                            />
                        </label>
                    </div> */}
                    {/* Right Side: Days Valid */}
                    <div className="w-1/2">
                        <label className="block text-gray-700 text-sm font-bold">
                            Days Valid
                            <input
                                type="text"
                                name="daysValid"
                                value={formData.numberOfDaysValid}
                                readOnly={true}
                                className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline mt-1"
                            />
                        </label>
                    </div>
                </div>
            </div>
            <div className="flex justify-between space-x-4 p-4">
                <label className="block text-gray-700 text-sm font-bold w-1/2">
                    Submit Date
                    <input
                        type="datetime-local"
                        name="submitDate"
                        value={formData.submitDate}
                        onChange={handleChange}
                        className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline mt-1"
                    />
                </label>
                <label className="block text-gray-700 text-sm font-bold w-1/2">
                    Est. Start Date
                    <input
                        type="datetime-local"
                        name="estStartDate"
                        value={formData.estStartDate}
                        onChange={handleChange}
                        className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline mt-1"
                    />
                </label>
            </div>
            <div className="flex justify-between space-x-4 p-4">
                <label className="block text-gray-700 text-sm font-bold w-1/2">
                    Proposal Class
                    <input
                        type="text"
                        name="proposalClass"
                        value={formData.proposalClass}
                        onChange={handleChange}
                        className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline mt-1"
                    />
                </label>
                <label className="block text-gray-700 text-sm font-bold w-1/2">
                    Choose a Template
                    <select
                        name="proposalTemplate"
                        value={formData.proposalTemplate}
                        onChange={handleChange}
                        className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline mt-1"
                    >
                        <option value="">Select</option>
                        <option value="template1">Template 1</option>
                        <option value="template2">Template 2</option>
                        <option value="template3">Template 3</option>
                    </select>
                </label>
            </div>
            <div className="flex justify-between space-x-4 p-4">
                <label className="block text-gray-700 text-sm font-bold w-1/2">
                    Proposal Subclass
                    <input
                        type="text"
                        name="proposalSubclass"
                        value={formData?.proposalSubclass?.subClassName}
                        onChange={handleChange}
                        className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline mt-1"
                    />
                </label>
                {/* <label className="block text-gray-700 text-sm font-bold w-1/2">
                    Work Phases
                    <input
                        type="number"
                        name="workPhases"
                        value={formData.workPhases}
                        onChange={handleChange}
                        className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline mt-1"
                    />
                </label> */}
            </div>
            <div className="flex flex-col space-y-4 p-4">
                <label className="block text-gray-700 text-sm font-bold">
                    Proposal Description
                    <textarea
                        name="description"
                        value={formData.description}
                        onChange={handleChange}
                        className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline mt-1"
                    />
                </label>
                <div className="flex justify-start space-x-4 items-center">
                    <label className="block text-gray-700 text-sm font-bold w-1/3">
                        Calculation Type
                        <select
                            name="calculationType"
                            value={formData.calculationType}
                            onChange={handleChange}
                            className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline mt-1"
                        >
                            <option value="" disabled>Select Calculation Type</option>
                            {[
                                'Price By Job',
                                'Price By Device',
                                'Price By Phase'
                            ].map((type, index) => (
                                <option key={index} value={type}>
                                    {type}
                                </option>
                            ))}
                        </select>
                    </label>
                </div>
            </div>
            <div className="flex justify-between space-x-4 p-4">
                {/* Left Section: Input Fields */}
                <div className="w-1/3 flex flex-col space-y-4">
                    <div className="flex justify-between items-center space-x-4">
                        <label className="block text-gray-700 text-sm font-bold w-full">
                            Proposal Amount
                            <input
                                type="number"
                                name="proposalAmount"
                                value={formData.proposalAmount}
                                onChange={handleChange}
                                className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline mt-1"
                            />
                        </label>
                        <label className="block text-gray-700 text-sm font-bold w-full">
                            Price Change
                            <input
                                type="number"
                                name="priceChange"
                                value={formData.priceChange}
                                onChange={handleChange}
                                className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline mt-1"
                            />
                        </label>
                        <label className="block text-gray-700 text-sm font-bold">
                            Taxable
                            <input
                                type="checkbox"
                                name="taxable"
                                checked={formData.taxable}
                                onChange={handleChange}
                                className="ml-2"
                            />
                        </label>
                    </div>
                    <label className="block text-gray-700 text-sm font-bold w-full">
                        # of Installments
                        <input
                            type="number"
                            name="numberOfInstallments"
                            value={formData.numberOfInstallments}
                            onChange={handleChange}
                            className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline mt-1"
                        />
                    </label>
                    <label className="block text-gray-700 text-sm font-bold w-full">
                        Installation Type
                        <select
                            name="installationType"
                            value={formData.installationType}
                            onChange={handleChange}
                            className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline mt-1"
                        >
                            <option value="" disabled>Select Installation Type</option>
                            {[
                                'Use Percents',
                                'Use Currency Amounts',
                                'Time and Materials + Amount Entered',
                                'Time and Materials only',
                                'Maintenance - periodic'
                            ].map((type, index) => (
                                <option key={index} value={type}>
                                    {type}
                                </option>
                            ))}
                        </select>
                    </label>
                    <label className="block text-gray-700 text-sm font-bold w-full">
                        Tax Exempt Number
                        <input
                            type="text"
                            name="taxExemptNumber"
                            value={formData.taxExemptNumber}
                            onChange={handleChange}
                            className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline mt-1"
                        />
                    </label>
                    <label className="block text-gray-700 text-sm font-bold w-full">
                        Violation Tracking
                        <input
                            type="checkbox"
                            name="violationTracking"
                            checked={formData.violationTracking}
                            onChange={handleChange}
                            className="ml-2"
                        />
                    </label>
                </div>
                {/* Right Section: Table */}
                <div className="w-2/3">
                    <table className="min-w-full bg-white border border-gray-300">
                        <thead>
                            <tr>
                                <th className="py-2 px-4 border-b text-center">Submitted</th>
                                <th className="py-2 px-4 border-b text-center">Proposal #</th>
                                <th className="py-2 px-4 border-b text-center">Description / Items</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td className="py-2 px-4 border-b text-center">{formData.submitDate}</td>
                                <td className="py-2 px-4 border-b text-center">{formData.proposalNumber}</td>
                                <td className="py-2 px-4 border-b text-center">{formData.description}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
            <div className="flex justify-end p-4">
                <button
                    onClick={handleSave}
                    className="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline ml-5"
                >
                    Save
                </button>
            </div>

        </div >
    );
};

export default ProposalLog;